function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useCallback, useContext, useMemo, useState } from "react";
import Label from "../../../../../grid/layouts/background-image-cards-grid/card-button/label/label";
import { ConditionalWrapper } from "utils/react";
import { getCapitilizedString } from "utils/strings";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { TIERS } from "constants/pricing";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import Button from "components/core/button/button-component";
import { shouldShowPurchaseNow } from "services/ab-tests/monetization-ab-tests-service";
import Colors from "styles/colors";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import { hasLearnMoreVideo, getVideoIdByLocaleAndTier } from "services/pricing-learn-more-service";
import YouTubePopUpButton from "segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button";
import { SECONDARY_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { trackEvent } from "services/bigbrain-service";
import { HP_SOURCE, CONTACT_US_BUTTON_CLICKED, PRICING_PAGE_FEATURE_INFO_ICON_HOVER, PRICING_PAGE_FEATURE_INFO_ICON_EXIT, PRICING_PAGE_FREE_TIER_COMING_SOON_HOVER, CONTACT_SALES_POPUP_FORM_CLOSE, CONTACT_SALES_POPUP_FORM_SUBMIT } from "constants/bigbrain-event-types";
import { useContactSalesTypeform } from "client/services/hooks/use-contact-cales-typeform";
import { CONTACT_US_FROM_HEADER_PAGE_LINK } from "constants/links";
import { HOMEPAGE_PRICING_TIER_SOURCE } from "constants/cookies";
import { PLATFORM_PRODUCT_IDS, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { ProductIcon } from "../../../../icons/product-icon";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import EnterpriseIcon from "/static/svg/pricing-enterprise-icon.svg";
import { ContactUsIcon } from "./contact-us-icon";
import { ProductPrice } from "./product-price/product-price";
import { withAbTests } from "/contexts/ab-tests-context";
import { shouldShowTypeformContactUs } from "/services/ab-tests/monetization-ab-tests-service";
import { getTierTranslationKey } from "/services/pricing/plans-service";
import { getDefaultContactUsPageLink } from "/services/pricing/pricing-page/contact-us-link-service";
import { setCookie } from "/services/cookies-service";
import { ModalGlobalStyles, StyledProductPriceAndFeatures, StyledProductPriceAndFeaturesWrapper } from "./product-price-and-features-card.scss";
import { shouldGetQuoteTextAndModal } from "services/ab-tests/acquisition-ab-test-service";
import ReactModal from "react-modal";
import { CONTACT_SALES_HUBSPOT_FORM_ID } from "/client/services/hubspot-service/contact-form-config";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import CloseIcon from "/static/svg/icons/close.svg";
import { maxNoTouchSeats, CARD_CLASS, DEFAULT_CONTACT_SALES_LINK, THANK_YOU_PAGE, THANK_YOU_PAGE_SB, HS_FROM_FIELD_VALUE } from "./consts";
import { HUBSPOT_CONTACT_SALES_CTA, HUBSPOT_CONTACT_SALES_CTA_TRANSLATED } from "/client/services/hubspot-service/hubspot-constants";
import { getRawTranslationValue } from "/services/localization/localization-service";
const ProductPriceAndFeatures = ({ productName, productId, period, tier, previousTierName, color, colorMobile, ctaHoverBackgroundColor, ctaHoverBorderColor, ctaHoverTextColor, primaryColor, secondaryColor, seats, isMostPopular, abTests, onPurchaseNowClicked, hideFreeForever, isHomepagePricing, isApplyMaxDiffFeatures, showLearnMoreVideo, showFreeTierComingSoon, labeledTierFeatures, getQuoteModalFullParagraph, hubspotFromFieldValue })=>{
    var _translate;
    const { name: tierName, features } = tier;
    const { translate, forcePricing, translateWithParam, localeId, isMobileOrTabletBrowser, simulateGetQuoteTextAndModal } = useContext(GenericConfigContext);
    const shouldShowPrices = tierName !== TIERS.ENTERPRISE && seats < maxNoTouchSeats;
    const canPurchaseNow = shouldShowPurchaseNow({
        abTests,
        forcePricing
    });
    const isFreeOrEnterprise = [
        TIERS.FREE,
        TIERS.ENTERPRISE
    ].includes(tierName);
    const [isGetQuotePopupOpen, setGetQuotePopupOpen] = useState(false);
    const shouldShowQuoteTextAndModal = simulateGetQuoteTextAndModal || shouldGetQuoteTextAndModal(abTests, true);
    const contactUsTranslateKey = shouldShowQuoteTextAndModal ? "pricingPage.get_quote" : "footer.contactSales";
    const contactUsText = translate(contactUsTranslateKey);
    const getQuoteSubmitEvent = {
        eventType: CONTACT_SALES_POPUP_FORM_SUBMIT,
        data: {
            productKind: productName
        }
    };
    const onPurchaseNowClick = (e)=>{
        const { currentTarget } = e;
        const purchaseNowLinkParent = currentTarget.closest(`div.${CARD_CLASS}`);
        const signupButton = purchaseNowLinkParent.querySelector("button");
        onPurchaseNowClicked({
            tier,
            target: signupButton
        });
    };
    const tierIncludesText = useMemo(()=>{
        return !previousTierName ? translateWithParam("pricingPage.tierCards.planIncludes", translate(getCapitilizedString(tier.name))) : translateWithParam("pricingPage.tierCards.includesPlanPlus", translate(previousTierName));
    }, [
        previousTierName,
        translateWithParam,
        tier,
        translate
    ]);
    const getLearnMoreButtonText = ()=>{
        return translateWithParam("pricingPage.tierCards.learnMoreButton", tier.name);
    };
    const featuresOrMaxDiffFeatures = useMemo(()=>{
        if (isHomepagePricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) {
            const { maxDiffFeatures } = tier;
            return isApplyMaxDiffFeatures && maxDiffFeatures ? maxDiffFeatures : features;
        }
        return features;
    }, [
        features,
        isApplyMaxDiffFeatures,
        isHomepagePricing,
        productName,
        tier
    ]);
    const renderLearnMoreVideoCTAOrPlaceholder = ()=>{
        const hasVideo = hasLearnMoreVideo(tier.name);
        return /*#__PURE__*/ _jsx("div", {
            className: "tier-learn-more-button",
            children: hasVideo && showLearnMoreVideo && /*#__PURE__*/ _jsx(YouTubePopUpButton, {
                isWithIcon: true,
                isWithIconInsteadOfArrow: true,
                withoutUnderline: true,
                minPadding: true,
                outline: true,
                isWithArrow: false,
                iconColor: color,
                buttonText: getLearnMoreButtonText(),
                videoId: getVideoIdByLocaleAndTier(localeId, tier.name),
                buttonDisplayType: SECONDARY_BUTTON_TYPE,
                extraEventData: {
                    buttonName: "hp_pp_tier_learn_more",
                    tier: tier.name,
                    locale: localeId
                }
            })
        });
    };
    const sendHoverEvent = (feature, eventName)=>{
        trackEvent(eventName, {
            info1: feature,
            info2: tier.name,
            kind: feature,
            productKind: productName
        });
    };
    const onMouseEnter = (feature)=>{
        sendHoverEvent(feature, PRICING_PAGE_FEATURE_INFO_ICON_HOVER);
    };
    const onMouseLeave = (feature)=>{
        sendHoverEvent(feature, PRICING_PAGE_FEATURE_INFO_ICON_EXIT);
    };
    const onMouseEnterComingSoon = (feature)=>{
        trackEvent(PRICING_PAGE_FREE_TIER_COMING_SOON_HOVER, {
            info2: tier.name,
            productKind: productName
        });
    };
    const showComingSoon = useMemo(()=>{
        return showFreeTierComingSoon && tierName === TIERS.FREE;
    }, [
        showFreeTierComingSoon,
        tierName
    ]);
    const onContactUsClick = useCallback(()=>{
        var _localStorage, _localStorage1;
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(HUBSPOT_CONTACT_SALES_CTA, getRawTranslationValue(contactUsTranslateKey));
        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(HUBSPOT_CONTACT_SALES_CTA_TRANSLATED, contactUsText);
        trackEvent(CONTACT_US_BUTTON_CLICKED, {
            placement: "tier-value-card",
            source: HP_SOURCE,
            info1: tier.name,
            info2: seats,
            productKind: productName,
            data: {
                buttonText: contactUsText
            }
        });
        if (shouldShowQuoteTextAndModal) {
            setGetQuotePopupOpen(true);
        } else {
            window.location.href = DEFAULT_CONTACT_SALES_LINK;
        }
    }, [
        abTests,
        productName,
        seats,
        tier.name
    ]);
    const closeModal = ()=>{
        setGetQuotePopupOpen(false);
        trackEvent(CONTACT_SALES_POPUP_FORM_CLOSE);
    };
    const handleBeforeSubmitCallback = ()=>{
        setCookie(HOMEPAGE_PRICING_TIER_SOURCE, `${productName}-${tierName}`);
    };
    const productColor = typeof colorMobile === "string" ? colorMobile : color;
    return /*#__PURE__*/ _jsxs(ConditionalWrapper, {
        condition: isHomepagePricing,
        wrapper: (children)=>/*#__PURE__*/ _jsxs(StyledProductPriceAndFeaturesWrapper, {
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                className: classnames("card-container", {
                    "is-homepage-pricing": isHomepagePricing,
                    "is-most-popular": isMostPopular
                }),
                children: [
                    isHomepagePricing && isMostPopular && /*#__PURE__*/ _jsx("div", {
                        className: "most-popular",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "most-popular-span",
                            children: translate("pricingPage.mostPopular")
                        })
                    }),
                    children
                ]
            }),
        children: [
            /*#__PURE__*/ _jsxs(StyledProductPriceAndFeatures, {
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                className: classnames(CARD_CLASS, {
                    "is-most-popular": isMostPopular
                }),
                style: {
                    "--primary-color": primaryColor,
                    "--secondary-color": secondaryColor
                },
                children: [
                    !isHomepagePricing && /*#__PURE__*/ _jsx("div", {
                        className: "icons",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "icon",
                            style: {
                                "--product-color": productColor
                            },
                            children: /*#__PURE__*/ _jsx(ProductIcon, {
                                product: productName
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tier-title-container",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "tier-title",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "product-and-tier",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "tier",
                                            children: translate(getTierTranslationKey(tierName, {
                                                hasStudentPlan: false
                                            }))
                                        }),
                                        isHomepagePricing && showComingSoon && /*#__PURE__*/ _jsx("div", {
                                            onMouseEnter: onMouseEnterComingSoon,
                                            className: "coming-soon",
                                            children: translate("pricingPage.comingSoon")
                                        }),
                                        !isHomepagePricing && productName !== PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID] && /*#__PURE__*/ _jsx("div", {
                                            children: translate(`pricingPage.products.${productName}.title`)
                                        })
                                    ]
                                }),
                                !isHomepagePricing && isMostPopular && /*#__PURE__*/ _jsx("div", {
                                    className: "most-popular-badge-container",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "most-popular-badge",
                                        children: translate("pricingPage.mostPopular")
                                    })
                                })
                            ]
                        })
                    }),
                    shouldShowPrices ? /*#__PURE__*/ _jsx(ProductPrice, {
                        product: productName,
                        period: period,
                        seats: seats,
                        tierName: tierName,
                        hideFreeForever: hideFreeForever,
                        splitCurrencySign: isHomepagePricing
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "contact",
                        children: isHomepagePricing ? /*#__PURE__*/ _jsx(EnterpriseIcon, {}) : /*#__PURE__*/ _jsx(ContactUsIcon, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("cta-button", {
                            "try-cta-padding": canPurchaseNow && isFreeOrEnterprise,
                            "contact-us": !shouldShowPrices
                        }),
                        children: shouldShowPrices ? /*#__PURE__*/ _jsx("div", {
                            className: "signup-form-wrapper",
                            children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                                className: "signup-form",
                                ctaText: translate("signup.tryForFree"),
                                buttonSize: "xs",
                                forceInputHide: true,
                                useCtaText: true,
                                buttonSpinnerColor: Colors[BRAND_BLACK_TEXT_COLOR],
                                pricingDetails: {
                                    tier: tierName,
                                    userCount: seats,
                                    billingPeriod: period,
                                    product: productName
                                },
                                signupProductId: productId,
                                extraData: {
                                    pricing_tier: tierName,
                                    cta_name: "tier_cards"
                                },
                                beforeSubmitCallback: handleBeforeSubmitCallback
                            })
                        }) : /*#__PURE__*/ _jsx(Button, {
                            className: classnames("cta-button", "contact-us-button"),
                            type: "button",
                            size: "xs",
                            onClickCallback: onContactUsClick,
                            children: contactUsText
                        })
                    }),
                    canPurchaseNow && !isFreeOrEnterprise && /*#__PURE__*/ _jsxs("div", {
                        className: "pricing-signup-purchase-now",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: (_translate = translate("signup.or")) === null || _translate === void 0 ? void 0 : _translate.toLowerCase()
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                className: "purchase-now-link",
                                onClick: onPurchaseNowClick,
                                children: translate("pricingPage.purchaseNow")
                            })
                        ]
                    }),
                    isHomepagePricing && renderLearnMoreVideoCTAOrPlaceholder(),
                    /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: translate(`pricingPage.products.${productName}.tiers.${tier.name}.description`)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "horizontal-line"
                    }),
                    isHomepagePricing && /*#__PURE__*/ _jsx("div", {
                        className: "tier-include",
                        children: tierIncludesText
                    }),
                    featuresOrMaxDiffFeatures === null || featuresOrMaxDiffFeatures === void 0 ? void 0 : featuresOrMaxDiffFeatures.map((feature)=>/*#__PURE__*/ _jsxs("div", {
                            className: "feature",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "name-and-label",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: translate(`pricingPage.products.${productName}.tiers.${tierName}.features.${feature}`)
                                            }
                                        }),
                                        labeledTierFeatures[feature] && /*#__PURE__*/ _jsx(Label, {
                                            text: translate(labeledTierFeatures[feature]),
                                            borderColor: "blue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "icon",
                                    onMouseEnter: ()=>onMouseEnter(feature),
                                    onMouseLeave: ()=>onMouseLeave(feature),
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "tooltip",
                                            children: /*#__PURE__*/ _jsx(TooltipComponent, {
                                                theme: DARK_THEME,
                                                className: "floating-tooltip",
                                                children: translate(`pricingPage.products.${productName}.tiers.${tierName}.features.${feature}.description`)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(PricingInfoIcon, {
                                            className: "info-icon"
                                        })
                                    ]
                                })
                            ]
                        }))
                ]
            }),
            /*#__PURE__*/ _jsxs(ReactModal, {
                isOpen: isGetQuotePopupOpen,
                overlayClassName: "react-modal-overlay",
                className: "react-modal-content",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${ModalGlobalStyles.__hash}` + " " + "get-quote-modal-container",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                onClick: closeModal,
                                className: `jsx-${ModalGlobalStyles.__hash}` + " " + "modal-close-icon",
                                children: /*#__PURE__*/ _jsx(CloseIcon, {})
                            }),
                            /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, getQuoteModalFullParagraph)),
                            /*#__PURE__*/ _jsx(HubspotContactForm, {
                                formId: CONTACT_SALES_HUBSPOT_FORM_ID,
                                urlToRedirectAfterSubmission: THANK_YOU_PAGE,
                                urlToRedirectAfterSubmissionForSmallBusinesses: THANK_YOU_PAGE_SB,
                                dontRenderPostFormSubmit: true,
                                hubspotFromHiddenField: hubspotFromFieldValue,
                                externalEventsForSubmit: getQuoteSubmitEvent,
                                isV2: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(_JSXStyle, {
                        id: ModalGlobalStyles.__hash,
                        children: ModalGlobalStyles
                    })
                ]
            })
        ]
    });
};
export default withAbTests(ProductPriceAndFeatures);
